import { Injectable } from '@angular/core';
import { AbstractHttpService } from '../commons/abstract-http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PacDocumentos } from '../model/pack-documentos';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CredorService extends AbstractHttpService {

  private ENDPOINT_POST_ANEXAR_DOCS = 'api/restituicao/anexar-documentos';


  constructor(http: HttpClient) {
    super(http);
  }

  anexarDocumentos(protocolo: string, documentoPack: PacDocumentos ): Observable<any>{
    const formData = new FormData();
    //this.setarFormData(documentoPack, formData);
    formData.set('protocolo', protocolo);
    return this.postWithMultiPartFile<any>(this.ENDPOINT_POST_ANEXAR_DOCS, formData);
  }

  // private setarFormData(pacDocumento: PacDocumentos, formData: FormData) {

  //   pacDocumento.descricao.forEach(descricao => {
  //     formData.append('descricao', descricao);
  //   });

  //   pacDocumento.tipoDocumentoEnum.forEach(tipoDocumentoEnum => {
  //     formData.append('tipoDocumentoEnum', tipoDocumentoEnum.key);
  //   });

  //   pacDocumento.extensao.forEach(extensao => {
  //     formData.append('extensao', extensao);
  //   });

  //   pacDocumento.arquivo.forEach(arquivo => {
  //     formData.append('arquivo', arquivo, arquivo['name']);
  //   });

  // }

  protected postWithMultiPartFile<T>(relativePath: string, formData: FormData): Observable<T> {

    return this.http.post<T>(this.url + relativePath, formData, { headers: CredorService.getMultiPartHeaders() });
  }

  static getMultiPartHeaders() {
    const headers = new HttpHeaders();
    headers.append('Authorization', 'Bearer');
    headers.set('Accept', 'application/json');
    return headers;

  }

}

